import React from "react";

const Button = ({ text, handler, primary }) => (
    <div
        css={{
            padding: "10px 20px",
            borderRadius: primary ? 3 : 0,
            fontSize: ".8em",
            fontWeight: 500,
            backgroundColor: primary ? "rgba(100, 100, 100, .3)" : "none",
            color: "lightgrey",
            transition: "color var(--transition-default-time) ease",
            cursor: "pointer",
            ":hover": {
                color: "var(--green)",
            },
        }}
        onClick={ handler }
    >
        { text }
    </div>
);

export default ({ title, message, okText, okHandler, cancelText, cancelHandler }) => {
    const overlay = React.useRef(null);
    const dialog = React.useRef(null);

    React.useEffect(() => {
        overlay.current.style.opacity = 1;
        dialog.current.style.transform = "scale(1)";
    }, []);

    return (
        <div
            ref={ overlay }
            style={{
                opacity: 0,
            }}
            css={{
                position: "fixed",
                top: 0,
                left: 0,
                height: "100vh",
                width: "100vw",
                backgroundColor: "rgba(0, 0, 0, .8)",
                zIndex: 42,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: ".9em",
                transition: "opacity var(--transition-default-time) ease",
                "@supports (backdrop-filter: blur())": {
                    backgroundColor: "rgba(0, 0, 0, .5)",
                    backdropFilter: "blur(15px)",
                },
            }}
        >
            <div
                ref={ dialog }
                style={{
                    transform: "scale(0.5)",
                }}
                css={{
                    maxWidth: 400,
                    borderRadius: 3,
                    backgroundColor: "rgba(35, 35, 35, 1)",
                    boxShadow: "0px 15px 50px -10px black",
                    transition: "transform var(--transition-default-time) ease",
                }}
            >
                <div css={{
                    padding: 20,
                }}>
                    <div css={{
                        marginBottom: 10,
                        fontWeight: 600,
                        textTransform: "uppercase",
                    }}>
                        { title }
                    </div>
                    <div>{ message }</div>
                </div>
                <div css={{
                    padding: 15,
                    marginTop: 15,
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "flex-end",
                    borderBottomLeftRadius: 3,
                    borderBottomRightRadius: 3,
                    backgroundColor: "rgba(15, 15, 15, .8)",
                }}>
                    <Button text={ cancelText || "No" } handler={ cancelHandler } />
                    <Button text={ okText || "Yes" } handler={ okHandler } primary={ true } />
                </div>
            </div>
        </div>
    );
};
